// extracted by mini-css-extract-plugin
module.exports = {"input":"JOAm_","button":"_32v5r"};